<template lang="pug">
v-container(fluid v-if="$store.state.user && $store.state.user.role === 1")
	v-window(v-model="page" touchless)
		v-window-item
			v-data-table.mb-16(:headers="headers" :items="members" hide-default-footer disable-pagination no-results-text="查無資料" :search="search")
				template(v-slot:body="{items}")
					tbody
						tr(v-for="item,i in items" :key="i")
							td.text-left {{item.account}}
							td.text-left {{item.year}}
							td.text-left {{item.name}}
							td.text-left(style="white-space: pre-line;") {{(item.identity||[]).join('\n')}}
							td.text-left {{item.phone}}
							td.text-left {{item.email}}
							td.text-left {{Object.entries(item.auth).filter(x=>x[1]).map(x=>x[0]).join(',')}}
							td.text-left(style="white-space: pre-line;") {{(item.route||[]).join('\n')}}
							td.text-center
								v-switch(:input-value="item.enable === 1" @change="Enable(item)" color="orange" inset)
							td.text-center
								v-layout
									v-btn(plain small @click.stop.prevent="startEdit(item)")
										v-icon mdi-pencil
									v-btn(plain small @click="removeMember(item.account)")
										v-icon mdi-delete
			v-dialog(v-model="dialog" :max-width="600")
				v-card.pa-3
					v-layout
						v-text-field(label="帳號" v-model="editing.account" :disabled="tmpInput.isEdit")
						v-text-field(label="密碼" v-model="editing.password" type="password" placeholder="不修改請留空" autocomplete="new-password")
						v-text-field(label="姓名" v-model="editing.name")
					v-layout
						v-select(label="年分" :items="yearOptions" item-text="text" item-value="value" v-model="editing.year" placeholder="請選擇年分")
					v-layout(align-center)
						v-chip(label) 身分
						v-chip(v-for="(id,i) in editing.identity" :key="i" :title="id" label close @click:close="editing.identity.splice(i,1)") {{id.slice(0,4)}}
						v-spacer
						v-select(v-model="tmpInput.identity" :items="identity")
						v-btn(small @click="addInput('identity')")
							v-icon mdi-plus
					v-layout.flex-wrap(v-if="category.includes('route')")
						v-chip(label) {{getCategoryName('route')}}
						v-chip(v-for="(e,ei) in editing.route" :key="ei" :title="e" label close @click:close="editing.route.splice(ei,1)") {{e.slice(0,4)}}
						v-layout
							v-select.mt-n3(small v-model="tmpInput.route" :items="ctable.route ? ctable.route.map(x=>x.target) : []")
							v-btn(small @click="addInput('route')")
								v-icon mdi-plus
					v-layout
						v-text-field(label="電話" v-model="editing.phone")
						v-text-field(label="信箱" v-model="editing.email")
					v-layout(align-center)
						v-checkbox(label="瀏覽問卷" v-model="editing.auth.browse")
						v-checkbox(label="管理者" v-model="editing.auth.admin")
						v-spacer
						v-btn(v-if="tmpInput.isEdit" @click="updateMember(false)") {{saving?'':'完成'}}
							v-progress-circular(v-if="saving" indeterminate)
						v-btn(v-else @click="addMember()") {{saving?'':'新增'}}
							v-progress-circular(v-if="saving" indeterminate)
		v-window-item.pa-2
			.d-flex.align-start.flex-wrap
				div
					v-chip(label).pink.white--text 類別
					v-chip(v-for="ckey in category" :key="ckey" label ) {{getCategoryName(ckey)}}
				v-spacer
				//- v-text-field(dense label="新類別" v-model="tmpInput.category")
				//- v-btn(small @click="addCategory()")
				//- 	v-icon mdi-plus
			.d-flex.align-start.flex-wrap
				v-chip(label).pink.white--text 身分
				v-chip(v-for="ikey,i in identity" :key="i" label) {{ikey}}
				v-spacer
				//- v-text-field(dense label="新身分" v-model="tmpInput.identity")
				//- v-btn(small @click="identity=identity.includes(tmpInput.identity)||tmpInput.identity==''?identity:[...identity,tmpInput.identity]")
				//- 	v-icon mdi-plus
			v-row.mt-2
				v-flex(v-for="ckey in category" :key="ckey" :class="ckey === 'route' ? 'xs12 md6 lg6' : 'xs12 md4 lg3'" class="pa-2")
					v-card(style="border-radius: 10px").pa-2
						v-layout(justify-center wrap).pa-2
							v-chip.mr-1(label) {{getCategoryName(ckey)}}
							v-chip.mr-1(label)
								input(type="text" placeholder="名稱" v-model="cInput[ckey].target" style="width: 100px")
							v-chip.mr-1(label v-if="ckey === 'route'")
								input(type="number" placeholder="數量" v-model.number="cInput[ckey].total" style="width: 50px")
							v-chip(label dark v-if="cInput[ckey].isEdit" @click="updateCtable(ckey)").cyan 完成
							v-chip(label v-else @click="addCtable(ckey)") 新增
							div(style="flex-basis:100%; height:12px" v-if="ckey === 'route'")
							v-chip.mr-1(label v-if="ckey === 'route'" style="height: 55px;")
								v-select(:items="businessOptions.map(name => ({ text: name, value: businessMap[name] }))" v-model="cInput[ckey].business_id" label="客運業者" dense style="width: 100px;" hide-details)
							v-chip.mr-1(label v-if="ckey === 'route'" style="height: 55px;")
								v-select(:items="unitOptions.map(name => ({ text: name, value: unitMap[name] }))" v-model="cInput[ckey].unit_id" label="推動單位" dense style="width: 100px;" hide-details)
							v-chip.mr-1(label v-if="ckey === 'route'" style="height: 55px;")
								v-select(:items="identityOptions.map(name => ({ text: name, value: identityMap[name] }))" v-model="cInput[ckey].identity_id" label="身分" dense style="width: 100px;" hide-details)
						table.table
							tr
								td {{getCategoryName(ckey)}}
								td(v-if="ckey === 'route'" style="width: 1%; white-space: nowrap;") 問卷總數
								td(v-if="ckey === 'route'") 身分
								td(style="width: 1%; white-space: nowrap;") 操作
							tr(v-for="ct in ctable[ckey]" :key="ct.target")
								td {{ct.target}}
								td(v-if="ckey === 'route'") {{ct.total}}
								td(v-if="ckey === 'route'") {{ct.identity_name || '—'}}
								td
									v-btn.ma-1(plain small @click="cInput[ckey]={id: ct.id, target: ct.target, total: ckey === 'route' ? ct.total : 0, business_id: ct.business_id, unit_id: ct.unit_id, identity_id: ct.identity_id, isEdit: true};$set(category,0,category[0]);").my-0
										v-icon mdi-pencil
									v-btn.ma-1(plain small @click="deleteCtable(ckey, ct)").my-0
										v-icon mdi-delete
	v-layout.psf
		v-text-field(label="搜尋" v-model="search"
			:style="{width: toggle?'200px':0, transition: '0.5s'}")
		v-btn.ma-1(@click="toggle=!toggle")
			v-icon mdi-file-find
		v-btn.ma-1(v-if="page==0" @click="page=1")
			v-icon mdi-cog
		v-btn.ma-1(v-if="page==1" @click="saveAll()")
			v-icon mdi-content-save
		v-btn.ma-1(@click="newEdit();tmpInput.isEdit=false;dialog=true")
			v-icon mdi-plus
</template>

<script>
import axios from 'axios';

export default {
	name: 'settings',
	data() {
		return {
			dialog: false,
			toggle: false,
			saving: false,
			page: 0,
			headers: [
				{ text: '帳號', value: 'account', align: 'left' },
				{ text: '年分', value: 'year', align: 'left' },
				{ text: '姓名', value: 'name', align: 'left' },
				{ text: '身分', value: 'identity', align: 'left' },
				{ text: '電話', value: 'phone', align: 'left' },
				{ text: '信箱', value: 'email', align: 'left' },
				{ text: '權限', value: 'auth', align: 'left' },
			],
			members: [],
			search: '',
			identity: [],
			category: ['business', 'unit', 'route'],
			ctable: {
				business: [],
				unit: [],
				route: []
			},
			cInput: {
				business: { target: '', isEdit: false },
				unit: { target: '', isEdit: false },
				route: { target: '', total: 0, business_id: null, unit_id: null, isEdit: false }
			},
			editing: {
				account: '',
				password: '',
				year: '',
				name: '',
				identity: [],
				phone: '',
				email: '',
				history: [],
				auth: { admin: false, browse: false },
			},
			tmpInput: { category: '', identity: '', route: '', isEdit: false },
			businessMap: {},
			unitMap: {},
			routeMap: {},
			identityMap: {},
			identityOptions: [],
			businessOptions: [],
			unitOptions: [],  
			routeOptions: [],
			yearOptions: [],
			yearMap: [],
		};
	},
	methods: {
		newEdit() {
			let newOne = {
				account: '',
				password: undefined,
				year: '',
				name: '',
				identity: [],
				phone: '',
				email: '',
				history: [],
				auth: { admin: false, browse: false },
			};
			this.category.map((key) => {
				newOne[key] = [];
			});
			this.editing = newOne;
			this.tmpInput.identity = '';
			this.tmpInput.route = '';
		},
		// 類別名稱轉成中文
		getCategoryName(key) {
			const categoryNameMap = {
				'business': '客運業者',
				'unit': '推動單位',
				'route': '路線',
			};
			return categoryNameMap[key] || key;
		},
		// 路線要是陣列
		memberTypeCheck() {
			this.members = this.members.map((x) => {
				if (!x.route) {
					x.route = [];
				}
				return x;
			});
		},
		// 取得會員列表
		async fetchAccountList() {
			// 取得年分
			const year = this.$store.state.selectedYear;
			if (year == null || year === '' || year === undefined) {
				this.members = [];
				return;
			}

			try {
				const response = await axios.get('/api/Account/AccountList',{
					params: { year }
				});
				if (response.data.status && response.data.result) {
					// 處理格式(陣列)
					this.members = response.data.result.map(account => {
						const processArray = (arr) => {
							if (!Array.isArray(arr) || arr.length === 0) return [];
							if (typeof arr[0] === 'string' && arr[0].includes(',')) {
								return arr[0].split(',').map(item => item.trim());
							}
							return arr;
						};
						
						const route = processArray(account.route || []);
						// 權限型態變成數字
						const role = account.role === '1' || account.role === 1 ? 1 : 
						             account.role === '2' || account.role === 2 ? 2 : 0;
						
						const member = {
							id: account.id || '',
							account: account.account || '',
							year: account.year || '',
							name: account.name || '',
							enable: account.enable ?? 1,
							identity: Array.isArray(account.identity) ? account.identity : [],
							phone: account.phone || '',
							email: account.email || '',
							enable: account.enable ?? 1,
							auth: {
								admin: account.role === '1',
								browse: role === 2
							}
						};
						
						member.route = route;
						
						return member;
					});
					
					this.memberTypeCheck();
					
					// 補動態欄位表頭
					if (!this.headers.find(h => h.value === 'route')) {
						this.headers.push({ text: '路線', value: 'route' });
					}

					if (!this.headers.find(h => h.text === '狀態')) {
						this.headers.push({ text: '狀態', align: 'left' });
					}

					if (!this.headers.find(h => h.text === '操作')) {
						this.headers.push({ text: '操作', align: 'left' });
					}
				} else {
					this.members = [];
				}
			} catch (error) {
				this.members = [];
			}
		},
		// 路線&客運業者&推動單位列表
		async loadRouteAndBusinessAndUnit() {
			const year = this.$store.state.selectedYear;
			if (year == null || year === '' || year === undefined) {
				this.routeOptions = [];
				this.businessOptions = [];
				this.unitOptions = [];
				this.ctable.route = [];
				this.ctable.business = [];
				this.ctable.unit = [];
				return;
			}

			const routeAndBusinessAndUnitResponse = await axios.get('/api/Account/RouteAndBusinessAndUnitList', {
					params: { year }
				});
			if (routeAndBusinessAndUnitResponse.data.status && routeAndBusinessAndUnitResponse.data.result) {
				const result = routeAndBusinessAndUnitResponse.data.result;
				
				// 處理客運業者
				if (result.business) {
					this.businessOptions = result.business.map(item => item.name);
					result.business.forEach(item => {
						this.businessMap[item.name] = item.id;
					});
					this.ctable.business = result.business.map(item => ({
						id: item.id,
						target: item.name
					}));
				}
				// 處裡推動單位
				if (result.unit) {
					this.unitOptions = result.unit.map(item => item.name);
					result.unit.forEach(item => {
						this.unitMap[item.name] = item.id;
					});
					this.ctable.unit = result.unit.map(item => ({
						id: item.id,
						target: item.name
					}));
				}
				// 處裡路線
				if (result.routes) {
					this.routeOptions = result.routes.map(item => item.name);
					result.routes.forEach(item => {
						this.routeMap[item.name] = item.id;
					});
					this.ctable.route = result.routes.map(item => ({
						id: item.id,
						target: item.name,
						total: item.count || 0,
						business_id: item.business_id || null,
						business: item.business_name || '',
						unit_id: item.unit_id || null,
						unit: item.unit_name || '',
						identity_id: item.identity_id || null,
						identity_name: item.identity_name || '',
					}));
				}
			}
		},
		// 身分&年份列表
		async loadAllOptions() {
			try {
				const identityResponse = await axios.get('/api/Account/IdentityList');
				if (identityResponse.data.status && identityResponse.data.result) {
					this.identityOptions = identityResponse.data.result.map(item => item.name);
					identityResponse.data.result.forEach(item => {
						this.identityMap[item.name] = item.id;
					});
					this.identity = this.identityOptions;
				}

				const yearResponse = await axios.get('/api/Account/YearList');
				if (yearResponse.data.status && yearResponse.data.result) {
					this.yearOptions = yearResponse.data.result.map(item => item.year);
					yearResponse.data.result.forEach(item => {
						this.yearMap[item.name] = item.id;
					});
					this.year = this.yearOptions;
				}

				await this.loadRouteAndBusinessAndUnit();
			} catch (error) {
				alert('載入選項列表失敗');
			}
		},
		// 名稱轉換成ID
		convertNamesToIds(names, map) {
			return names
				.map(name => map[name])
				.filter(id => id !== undefined && id !== null);
		},
		// 新增帳號
		async addMember() {
			if (!this.editing.account || !this.editing.password || !this.editing.name) {
				alert('請填寫帳號、密碼和姓名');
				return;
			}
			
			this.saving = true;
			try {
				const identityIds = this.convertNamesToIds(this.editing.identity || [], this.identityMap);
				const routeIds = this.convertNamesToIds(this.editing.route || [], this.routeMap);

				let role = '0';
				if (this.editing.auth.admin) {
					role = '1';
				} else if (this.editing.auth.browse) {
					role = '2';
				}
				// 組成API的payload
				const requestData = {
					account: this.editing.account,
					password: this.editing.password,
					year: this.editing.year,
					name: this.editing.name,
					identity: identityIds.length > 0 ? identityIds : [],
					phone: this.editing.phone || '',
					email: this.editing.email || '',
					role: role,
					route: routeIds.length > 0 ? routeIds : [],
				};
				const response = await axios.post('/api/Account/Create', requestData);
				// 重製表單
				if (response.data.status) {
					alert(response.data.message || '帳號建立成功！');
					await this.fetchAccountList();
					this.dialog = false;
					this.tmpInput.isEdit = false;
					this.newEdit();
					this.tmpInput.identity = '';
					this.tmpInput.route = '';
				} else {
					alert(response.data.message || '帳號建立失敗');
				}
			} catch (error) {
				alert(error.response?.data?.message || '新增帳號失敗，請稍後再試');
			} finally {
				this.saving = false;
			}
		},
		startEdit(item) {
			this.dialog = true;
    		this.tmpInput.isEdit = true;
			this.$nextTick(() => {
				this.editing = {
					...item,
					id: item.id,
					password: '' 
				};
				this.tmpInput.identity = '';
				this.tmpInput.route = '';
			});
		},
		// 更新帳號
		async updateMember(){
			this.saving = true;
			try {
				const identityIds = this.convertNamesToIds(this.editing.identity || [], this.identityMap).filter(id => id > 0);
				const routeIds = this.convertNamesToIds(this.editing.route || [], this.routeMap).filter(id => id > 0);

				let role = '0';
				if (this.editing.auth.admin) {
					role = '1';
				} else if (this.editing.auth.browse) {
					role = '2'; 
				}
				const requestData = {
					id: parseInt(this.editing.id),
					year: this.editing.year || '',
					name: this.editing.name || '',
					phone: this.editing.phone || '',
					email: this.editing.email || '',
					role: role,
					identity: identityIds.length > 0 ? identityIds : [],
					route: routeIds.length > 0 ? routeIds : [],
				};
				// 有輸入密碼才更新
				if (this.editing.password !== undefined && this.editing.password !== null && this.editing.password !== '' && this.editing.password !== 'string' && String(this.editing.password).trim().length > 0) {
					requestData.password = this.editing.password;
				}
				
				const response = await axios.post('/api/Account/Update', requestData);
				if (response.data.status) {
					alert(response.data.message || '帳號更新成功！');
					this.fetchAccountList();
					this.dialog = false;
					this.tmpInput.isEdit = false;
					this.newEdit();
				} else {
					alert(response.data.message || '帳號更新失敗');
				}
			} catch (error) {
				alert(error.response?.data?.message || '更新帳號失敗，請稍後再試');
			} finally {
				this.saving = false;
			}
		},
		// 刪除帳號
		async removeMember(account) {
			const year = this.$store.state.selectedYear;
			const member = this.members.find((x) => x.account == account);
			if (!member || !member.id) {
				alert('無法找到帳號 ID');
				return;
			}
			
			if (confirm('確定要刪除這個帳號嗎？')) {
				try {
					const response = await axios.post(`/api/Account/Delete?id=${member.id}&year=${year}`);
					
					if (response.data.status) {
						alert(response.data.message || '帳號刪除成功！');
						await this.fetchAccountList();
					} else {
						alert(response.data.message || '帳號刪除失敗');
					}
				} catch (error) {
					alert(error.response?.data?.message || '刪除帳號失敗，請稍後再試');
				}
			}
		},
		// 帳號狀態(啟用/停用)
		async Enable(item) {
			if (!item || !item.id) {
				alert('無法取得帳號 ID');
				return;
			}
			const newEnable = item.enable === 1 ? 0 : 1;
			try {
				const response = await axios.post('/api/Account/Enable', {
					id: parseInt(item.id),
					enable: newEnable
				});
				if (response.data.status) {
					item.enable = newEnable;
				} else {
					alert(response.data.message || '更新狀態失敗');
				}
			} catch (error) {
				alert(error.response?.data?.message || '更新帳號狀態失敗');
			}
		},
		addInput(key) {
			if (!this.editing[key].includes(this.tmpInput[key]) && this.tmpInput[key]) {
				this.editing[key].push(this.tmpInput[key]);
			}
		},
		async addCtable(ckey) {
			if (!this.ctable[ckey]) {
				this.ctable[ckey] = [];
			}
			const year = this.$store.state.selectedYear;
			const target = this.cInput[ckey]?.target || '';
			const total = ckey === 'route' ? (this.cInput[ckey]?.total || 0) : 0;
    		const business_id = ckey === 'route' ? (this.cInput[ckey]?.business_id || 0) : 0;
    		const unit_id = ckey === 'route' ? (this.cInput[ckey]?.unit_id || 0) : 0;
    		const identity_id = ckey === 'route' ? (this.cInput[ckey]?.identity_id || 0) : 0;
			if (this.ctable[ckey].map((x) => x.target).includes(target)) {
				alert(ckey === 'business' ? '此客運業者已存在' : ckey === 'unit' ? '此推動單位已存在' : ckey === 'route' ? '此路線已存在' : ckey + '重複了');
				return;
			}
			// 新增客運業者
			if (ckey === 'business') {
				try {
					const requestData = {
						year: year,
						name: target,
						type: 1
					};
					
					const response = await axios.post('/api/Account/createBusinessAndUnit', requestData);
					
					if (response.data.status) {
						alert(response.data.message || '客運業者建立成功！');
						await this.loadAllOptions();
						this.cInput[ckey] = { target: '', total: 0, isEdit: false };
					} else {
						alert(response.data.message || '客運業者建立失敗');
					}
				} catch (error) {
					alert(error.response?.data?.message || '新增客運業者失敗，請稍後再試');
				}
			// 新增推動單位
			} else if (ckey === 'unit') {
				try {
					const requestData = {
						year: year,
						name: target,
						type: 2
					};
					
					const response = await axios.post('/api/Account/createBusinessAndUnit', requestData);
					
					if (response.data.status) {
						alert(response.data.message || '推動單位建立成功！');
						await this.loadAllOptions();
						this.cInput[ckey] = { target: '', total: 0, isEdit: false };
					} else {
						alert(response.data.message || '推動單位建立失敗');
					}
				} catch (error) {
					alert(error.response?.data?.message || '新增推動單位失敗，請稍後再試');
				}
			// 新增路線
			}  else if (ckey === 'route') { 
				try {
					const requestData = {
						year: year,
						name: target,
						count: total || 0,
						business_id: business_id,
						unit_id: unit_id,
						identity_id: identity_id
					};
					
					const response = await axios.post('/api/Account/createRoute', requestData);
					
					if (response.data.status) {
						alert(response.data.message || '路線建立成功！');
						await this.loadAllOptions();
						this.cInput[ckey] = { target: '', total: 0, business_id: null, unit_id: null, isEdit: false };
					} else {
						alert(response.data.message || '路線建立失敗');
					}
				} catch (error) {
					alert(error.response?.data?.message || '新增路線失敗，請稍後再試');
				}
			}
		},
		async updateCtable(ckey) {
			if (!this.cInput[ckey] || !this.cInput[ckey].id) {
				alert('無法取得 ID');
				return;
			}
			const year = this.$store.state.selectedYear;
			const target = this.cInput[ckey]?.target || '';
			const total = ckey === 'route' ? (this.cInput[ckey]?.total || 0) : 0;
    		const business_id = ckey === 'route' ? (this.cInput[ckey]?.business_id || 0) : 0;
    		const unit_id = ckey === 'route' ? (this.cInput[ckey]?.unit_id || 0) : 0;
			const identity_id = ckey === 'route' ? (this.cInput[ckey]?.identity_id || 0) : 0;
			// 更新客運業者
			if (ckey === 'business') {
				try {
					const requestData = {
						year: year,
						id: this.cInput[ckey].id,
						name: target
					};
					
					const response = await axios.post('/api/Account/updateBusinessAndUnit', requestData);
					
					if (response.data.status) {
						alert(response.data.message || '客運業者更新成功！');
						await this.loadAllOptions();
						this.cInput[ckey] = { target: '', total: 0, isEdit: false };
						this.$set(this.category, 0, this.category[0]);
					} else {
						alert(response.data.message || '客運業者更新失敗');
					}
				} catch (error) {
					alert(error.response?.data?.message || '更新客運業者失敗，請稍後再試');
				}
			// 更新推動單位
			} else if (ckey === 'unit') {
				try {
					const requestData = {
						year: year,
						id: this.cInput[ckey].id,
						name: target
					};
					
					const response = await axios.post('/api/Account/updateBusinessAndUnit', requestData);
					
					if (response.data.status) {
						alert(response.data.message || '推動單位更新成功！');
						await this.loadAllOptions();
						this.cInput[ckey] = { target: '', total: 0, isEdit: false };
						this.$set(this.category, 0, this.category[0]);
					} else {
						alert(response.data.message || '推動單位更新失敗');
					}
				} catch (error) {
					console.error('更新推動單位失敗:', error);
					alert(error.response?.data?.message || '更新推動單位失敗，請稍後再試');
				}
			// 更新路線
			} else if (ckey === 'route') { 
				try {
					const requestData = {
						year: year,
						id: this.cInput[ckey].id,
						name: target,
						count: total || 0,
						business_id: business_id,
						unit_id: unit_id,
						identity_id: identity_id
					};

					const response = await axios.post('/api/Account/updateRoute', requestData);
            
					if (response.data.status) {
						alert(response.data.message || '路線更新成功！');
						await this.loadAllOptions();
						this.cInput[ckey] = { target: '', total: 0, business_id: null, unit_id: null, isEdit: false };
						this.$set(this.category, 0, this.category[0]);
					} else {
						alert(response.data.message || '路線更新失敗');
					}
				} catch (error) {
					console.error('更新路線失敗:', error);
					alert(error.response?.data?.message || '更新路線失敗，請稍後再試');
				}
			}
		},
		async deleteCtable(ckey, ct) {
			if (!ct || !ct.id) {
				alert('無法取得 ID');
				return;
			}
			const year = this.$store.state.selectedYear;
			const itemName = ckey === 'business' ? '客運業者' : ckey === 'unit' ? '推動單位' : ckey === 'route' ? '路線' : '項目';
			// 刪除客運業者
			if (ckey === 'business') {
				try {
					const response = await axios.post(`/api/Account/deleteBusinessAndUnit?id=${ct.id}&year=${year}`);
					
					if (response.data.status) {
						alert(response.data.message || '客運業者刪除成功！');
						await this.loadAllOptions();
					} else {
						alert(response.data.message || '客運業者刪除失敗');
					}
				} catch (error) {
					alert(error.response?.data?.message || '刪除客運業者失敗，請稍後再試');
				}
			// 刪除推動單位
			} else if (ckey === 'unit') {
				try {
					const response = await axios.post(`/api/Account/deleteBusinessAndUnit?id=${ct.id}&year=${year}`);
					
					if (response.data.status) {
						alert(response.data.message || '推動單位刪除成功！');
						await this.loadAllOptions();
					} else {
						alert(response.data.message || '推動單位刪除失敗');
					}
				} catch (error) {
					alert(error.response?.data?.message || '刪除推動單位失敗，請稍後再試');
				}
			// 刪除路線
			} else if (ckey === 'route') {
				try {
					const response = await axios.post(`/api/Account/deleteRoute?id=${ct.id}&year=${year}`);
						
					if (response.data.status) {
						alert(response.data.message || '路線刪除成功！');
						await this.loadAllOptions();
					} else {
						alert(response.data.message || '路線刪除失敗');
					}
				} catch (error) {
					alert(error.response?.data?.message || '刪除路線失敗，請稍後再試');
				}
			}
		},
		saveAll() {
			this.page = 0;
		},
	},
	// 監聽selectedYear的變化
	watch: {
		'$store.state.selectedYear'() {
			this.loadRouteAndBusinessAndUnit();
			this.fetchAccountList();
		},
	},
	// 初始化
	mounted() {
		this.category.forEach((key) => {
			this.editing[key] = [];
			if (!this.cInput[key]) {
				if (key === 'route') {
					this.cInput[key] = { target: '', total: 0, isEdit: false };
				} else {
					this.cInput[key] = { target: '', isEdit: false };
				}
			}
			if (!this.ctable[key]) {
				this.ctable[key] = [];
			}
		});

		this.fetchAccountList();
		this.loadAllOptions();
	},
};
</script>